import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EftWireTransferCardsUI from '@src/pages/shared/EftWireTransferCardsUI';
import { instructionAdd, nextStep } from '@src/store/slice/autoUploadInstructionsSlice';

const EftWireTransferCards = ({ finishPage, type }) => {
  const dispatch = useDispatch();

  const { totalAutoLoading, integrationId, autoLoadingId } = useSelector(
    (state) => state?.autoUploadInstructions,
  );

  const pay = async () => {
    const body = {
      autoLoadingCreateRequestDto: {
        periodType: totalAutoLoading?.periodType,
        confirmEveryMonth: totalAutoLoading?.confirmEveryMonth,
        startDay: totalAutoLoading?.startDay,
        orderProcessType: totalAutoLoading?.orderProcessType,
        monthChoice: totalAutoLoading?.chooseMonth,
        paymentType: totalAutoLoading?.paymentType,
      },
    };

    if (integrationId && integrationId > 0) {
      body.integrationId = integrationId;
    }

    if (autoLoadingId && autoLoadingId > 0) {
      body.autoLoadingId = totalAutoLoading?.id;
    }

    const action = await dispatch(instructionAdd(body));

    if (instructionAdd.fulfilled.match(action)) {
      dispatch(nextStep());
    }
  };

  return <EftWireTransferCardsUI finishPage={finishPage} type={type} onContinue={pay} />;
};

export default EftWireTransferCards;
